import { useInfiniteQuery } from 'react-query';
import { SECURITIES_CACHE_KEY } from '../../Constants';
import { SecuritiesResults } from '../../models/Securities';
import { fetchSecurities } from '../../services/securities.service';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default (type, sort, marketStatus, filterConfig, pageSize) => {
  const cacheKeys: string[] = [sort.field, sort.asc];
  const filters: any = {};

  // eslint-disable-next-line guard-for-in,no-restricted-syntax
  for (const key in filterConfig) {
    filters[key] = {
      values: filterConfig[key],
    };

    for (const value of filterConfig[key]) {
      cacheKeys.push(`${key}:${value}`);
    }
  }

  return useInfiniteQuery<SecuritiesResults, Error>([SECURITIES_CACHE_KEY, type, marketStatus, ...cacheKeys], async ({ pageParam }) => fetchSecurities(type, sort, marketStatus, filters, pageSize, pageParam), {
    getNextPageParam: (lastPage, pages) => pages.length + 1,
  });
};
